import { Button, Form, Input, Modal, TimePicker } from 'antd';
import React, { useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import orderApi from '../../api/order';
import dayjs from 'dayjs';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const PickupModal = (props) => {
  const { open, currentData, onClose, onReload } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    pickup_time:
      currentData && currentData.pickup_time
        ? dayjs()
            .set('hour', currentData.pickup_time.split(':')[0])
            .set('minute', currentData.pickup_time.split(':')[1])
        : null,
    pickup_address:
      currentData && currentData.pickup_address
        ? currentData.pickup_address
        : '',
    drop_off: currentData && currentData.drop_off ? currentData.drop_off : '',
    driver_notes:
      currentData && currentData.driver_notes ? currentData.driver_notes : '',
  };

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then(async (values) => {
        let data = { ...values };
        data.pickup_time = data.pickup_time.format('HH:mm');
        await orderApi.updatePickup(currentData.id, data);
        setLoading(false);
        handleCancel();
        onReload();
      })
      .catch(() => setLoading(false))
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    onClose();
  };

  const handelFailed = (error) => {
    console.error(error);
  };

  return (
    <Modal
      open={open}
      width="60%"
      title={<IntlMessage id="global.add_pickup" />}
      onCancel={handleCancel}
      onOk={handleSubmit}
      footer={
        <>
          <Button onClick={onClose}>
            <IntlMessage id="global.cancel" />
          </Button>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            <IntlMessage id="global.save" />
          </Button>
        </>
      }
    >
      <Form
        {...layout}
        initialValues={initialValues}
        form={form}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={handelFailed}
      >
        <Form.Item
          name="pickup_time"
          label={<IntlMessage id="global.pickup_time" />}
          rules={[
            {
              required: true,
              message: 'Please input pickup time!',
            },
          ]}
        >
          <TimePicker placeholder="Select pickup time" format={'HH:mm'} />
        </Form.Item>
        <Form.Item
          name="pickup_address"
          label={<IntlMessage id="global.pickup_location" />}
          rules={[
            {
              required: true,
              message: 'Please input pickup location!',
            },
          ]}
        >
          <Input placeholder="Input pickup location" />
        </Form.Item>
        <Form.Item
          name="drop_off"
          label={<IntlMessage id="global.drop_off" />}
          rules={[
            {
              required: false,
              message: 'Please input pickup time!',
            },
          ]}
        >
          <Input placeholder="input drop off" format={'HH:mm'} />
        </Form.Item>
        <Form.Item
          name="driver_notes"
          label={<IntlMessage id="global.driver_notes" />}
          rules={[
            {
              required: false,
              message: 'Please input driver notes!',
            },
          ]}
        >
          <Input.TextArea rows={4} placeholder="Input driver_note" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PickupModal;
